import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://dailywit.news').replace(/\/$/, '');
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

// Site-wide default SEO / Open Graph tags. Page-level <Helmet> (e.g. ArticlePage)
// overrides any of these for its own route, preventing duplicate meta tags.
const DefaultSeo = () => (
  <Helmet>
    <title>Daily Wit - News with a Twist</title>
    <meta name="description" content="World news summarized with witty, sarcastic humor for busy adults. Get updated in 2 minutes." />
    <link rel="canonical" href={`${SITE_URL}/`} />

    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Daily Wit" />
    <meta property="og:url" content={`${SITE_URL}/`} />
    <meta property="og:title" content="Daily Wit - News with a Twist" />
    <meta property="og:description" content="World news summarized with witty, sarcastic humor for busy adults. Get updated in 2 minutes." />
    <meta property="og:image" content={DEFAULT_IMAGE} />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:url" content={`${SITE_URL}/`} />
    <meta name="twitter:title" content="Daily Wit - News with a Twist" />
    <meta name="twitter:description" content="World news summarized with witty, sarcastic humor for busy adults." />
    <meta name="twitter:image" content={DEFAULT_IMAGE} />
  </Helmet>
);

export default DefaultSeo;
